import './styles/not-found.css';

export default function NotFound() {
    return (
        <section className="not-found container" aria-labelledby="not-found-title">
            <p className="not-found__code" aria-hidden="true">404</p>
            <h1 id="not-found-title" className="not-found__title">Esta página no existe</h1>
            <p className="not-found__text">
                El enlace puede estar desactualizado. Desde el inicio se llega a los servicios,
                los equipos y los datos de contacto.
            </p>
            <a className="button button--ghost not-found__back" href="/">Volver al inicio</a>
        </section>
    );
}
